// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1w0lV","footer_nav":"Footer_footer_nav__62NUx","footer_nav_list":"Footer_footer_nav_list__1R4Rt"};